import NetworkService from "../config/interceptor/interceptor";

export interface SupportVideo {
  id: number;
  title: string;
  youtubeUrl: string;
  createdAt: string;
  updatedAt: string;
}

const unwrap = <T>(response: any): T => response?.data?.data ?? response?.data;

export const fetchSupportVideos = async (): Promise<SupportVideo[]> => {
  const response = await NetworkService.getInstance().sendHttpRequest({
    url: "support-videos",
    method: "GET",
    withLoader: true,
    withFailureLogs: true,
  });
  return unwrap<SupportVideo[]>(response);
};

export const createSupportVideo = async (
  title: string,
  youtubeUrl: string
): Promise<SupportVideo> => {
  const response = await NetworkService.getInstance().sendHttpRequest({
    url: "support-videos",
    method: "POST",
    data: { title, youtubeUrl },
    withLoader: true,
    withFailureLogs: true,
  });
  return unwrap<SupportVideo>(response);
};

export const deleteSupportVideo = async (id: number): Promise<void> => {
  await NetworkService.getInstance().sendHttpRequest({
    url: `support-videos/${id}`,
    method: "DELETE",
    withLoader: true,
    withFailureLogs: true,
  });
};
